<template>
  <div id="answerPage">
    <div
      class="pageHeader"
      :style="{
        backgroundImage:
          'url(' + require('@/assets/bg/top-bg-question.jpg') + ')',
      }"
    >
      <div class="container" v-if="this.$store.state.user.user">
        <router-link :to="`/topics/${this.$store.state.user.user.id}`">
          <img
            class="pageHeaderLogo"
            src="@/assets/logo/next-era-white.png"
            alt="VIR Logo"
          />
        </router-link>

        <div class="subPageController">
          <router-link
            :to="`/topics/${userId}/questions/${topicId}`"
            class="pageLink"
          >
            <font-awesome-icon class="backIcon" icon="long-arrow-alt-left" />
          </router-link>

          <router-link :to="`/topics/${userId}`" class="pageLink">
            Home
          </router-link>

          <font-awesome-icon icon="circle" class="desktop" />

          <router-link
            :to="`/topics/${userId}/questions/${topicId}`"
            class="pageLink desktop"
          >
            {{ topicTitle }}
          </router-link>

          <font-awesome-icon icon="circle" class="desktop" />

          <span class="blue desktop">Question {{ question.order }}</span>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="pageContentSubTitle">Question #{{ question.order }}</div>
      <div class="pageContentTitle">{{ question.title }}</div>
      <div class="pageDescription">
        Answers do not need to be formal or lengthy to provide value and should
        not require research. You can return to your saved answers to add or
        record more if you need to. You may submit recorded and/or written
        answers. When possible, please provide correct spellings of proper names
        mentioned in your recordings.
      </div>

      <div class="recordAnswerWrapper">
        <div class="title">Record Answer</div>
        <div class="_recordAnswerWrapper">
          <div class="recordAnswer" @click="onClickRecord">
            <div
              class="recordAnswerButtonWrapper"
              :class="{ recording: recordStatus }"
            >
              <div class="recordAnswerButton">
                <font-awesome-icon icon="circle" />
                <template v-if="recordStatus">Recording</template>
                <template v-else>Record</template>
              </div>

              <button
                class="stopRecording"
                @click.self.stop="stopRecording"
                v-if="recordStatus"
              >
                Stop
              </button>
              <div class="recordAnswerInstruction" v-else>
                You can answer this question with a voice recording.
              </div>
            </div>
          </div>
          <div class="transcribeWrapper">
            <!--<textarea v-model="question.answerCurrentTranscribe" />-->
            <!--<div id="result"></div>-->

            <template v-if="question.answerTranscribe">
              <!--<textarea v-model="question.answerCurrentTranscribe" />-->
              <div
                class="transcribeWrapperRow"
                v-for="(transcribe, index) in question.answerTranscribe"
                :key="transcribe.public_id"
              >
                <div class="transcribeWrapperRowTitle">
                  Recording #{{ index + 1 }}
                </div>
                <div class="transcribeWrapperRowButtons">
                  <div class="controls">
                    <!--<div class="playRecord"><font-awesome-icon icon="play" /></div>-->
                    <div class="downloadRecord" v-if="transcribe.secure_url">
                      <a
                        :href="`${transcribe.secure_url}`"
                        :download="`${transcribe.secure_url}`"
                        target="_blank"
                        ><font-awesome-icon icon="play"
                      /></a>
                    </div>
                  </div>
                  <div
                    class="deleteRecord"
                    @click="onClickDeleteRecord(transcribe.public_id, index)"
                  >
                    <font-awesome-icon icon="trash" />
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="writtenAnswer">
        <div class="title">Write Answer</div>
        <textarea v-model="question.answerWritten" />
      </div>
      

      <div class="attachFilesWrapper">
        <div class="left">
          <img src="@/assets/icon/icon-attach.png" alt="Icon Attach" />
        </div>
        <div class="mid">
          <div class="title">Attach Files</div>
          <div class="instruction">
            Do you have any images, pdfs, videos or other documents or files
            related to this question? You can upload those files here. You can
            also photograph items using the camera on your computer. Click Add
            Files and then select Camera to capture an image for upload.
          </div>
        </div>
        <div class="right">
          <button @click="openUploadModal">Add Files</button>
        </div>
      </div>
      <div class="attachFilesItems" v-if="attachFiles.length > 0">
        <div
          class="attachFilesItemsRow"
          v-for="file in attachFiles"
          :key="file.public_id"
        >
          <img :src="file.secure_url" />
          <div class="delete" @click="deleteAttachFile(file.public_id)">
            <font-awesome-icon icon="trash" />
          </div>
        </div>
      </div>
      <div class="submitAnswerWrapper">
        <button @click="backToTopic">Back To Topic</button>
        <button @click="saveAnswer">Save & Submit</button>
      </div>
      <div class="submitInstruction">
        You can press Save & Submit to record your progress at any point. You can
        also come back to add to your answer if you need to step away or if you
        think of something additional to contribute at a later date.
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      closeNotification: {
        answerWritten: null,
      },
      recordStatus: false,
      recordOptions: {
        recording: {},
        recordingFile: [],
      },
      speechOptions: {
        recognition: {},
      },
      userId: null,
      topicId: null,
      topicTitle: "",
      question: {
        title: "",
        answerWritten: "",
        answerRecord: "",
        answerCurrentTranscribe: "",
        answerTranscribe: [],
        recordFile: "",
        attachFiles: [],
        order: 1,
      },
      deleteAttachFiles: [],
      attachFiles: [],
    };
  },
  methods: {
    startRecording(result) {
      console.log(result)
      if(!result.value){
        return;
      }
      let items = [];
      navigator.mediaDevices.getUserMedia({ audio: true }).then((stream) => {
        let recorder = new MediaRecorder(stream);
        this.recordOptions.recording = recorder;
        recorder.addEventListener("dataavailable", (e) => {
          items.push(e.data);

          if (recorder.state == "inactive") {
            let blob = new Blob(items, { type: `${e.data.type}` });
            // let audio = document.getElementById("audio");
            // let mainAudio = document.createElement("audio");
            // mainAudio.setAttribute("controls", "controls");
            // audio.appendChild(mainAudio);

            // mainAudio.innerHTML = `<source src="${URL.createObjectURL(
            //   blob
            // )}" type="${e.data.type}" />`;

            this.uploadAudioToCloudinary(e.data, blob);
          }
        });
        /*
        recorder.ondataavailable = e => {
          items.push(e.data);
          window.console.log('e',e);
          if(recorder.state == 'inactive'){
            let blob = new Blob(items, {type: 'audio/webm'});
            let audio = document.getElementById('audio');
            let mainAudio = document.createElement('audio');
            mainAudio.setAttribute('controls', 'controls');
            audio.appendChild(mainAudio);
            window.console.log('blob', blob);
            window.console.log('blob2', URL.createObjectURL(blob));
            mainAudio.innerHTML = `<source src="${URL.createObjectURL(blob)}" type="video/webm" />`;

            stream.getTracks().forEach(function(track) {
              if (track.readyState == 'live') {
                  track.stop();
              }
            });
          }
        }
        */
        recorder.start(500);
        setTimeout(() => {
          this.recordStatus = true;
          this.startTranscribing();
        }, 1000);
      });
    },
    onClickRecord() {
      this.$swal({
        title: 'Are you ready to record?',
        type: 'warning',    
        confirmButtonText: 'Yes',
        cancelButtonText:'No',
        showCancelButton: true,
      }).then(this.startRecording);     

      
    },
    uploadAudioToCloudinary(data, blob) {
      window.console.log("url", URL.createObjectURL(blob));

      const instanceAxios = axios.create();
      instanceAxios.defaults.baseURL = "";
      instanceAxios.defaults.headers.common["Content-Type"] =
        "application/json";

      instanceAxios({
        method: "GET",
        url: URL.createObjectURL(blob), // blob url eg. blob:http://127.0.0.1:8000/e89c5d87-a634-4540-974c-30dc476825cc
        responseType: "blob",
      }).then((response) => {
        window.console.log("response create", response);

        let reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          let base64data = reader.result;

          const cloudinaryUrlApi =
            "https://api.cloudinary.com/v1_1/dm1y9o2zc/video/upload";
          const formData = new FormData();
          formData.append("file", base64data);
          formData.append("upload_preset", "pwdrpypp");
          const instanceAxios2 = axios.create();
          instanceAxios2.defaults.baseURL = "";
          instanceAxios2.defaults.headers.common["Content-Type"] =
            "multipart/form-data";
          delete instanceAxios2.defaults.headers.common["Authorization"];

          instanceAxios2({
            method: "POST",
            url: cloudinaryUrlApi,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
          }).then((cloudRes) => {
            if (cloudRes.status == 200) {
              const uploadAttachmentVideoDbRes = axios.post(
                "user/uploadAttachmentVideoDb",
                {
                  topicId: `${this.$route.params.topicId}`,
                  questionId: `${this.$route.params.questionId}`,
                  userId: `${this.$route.params.userId}`,
                  fileName: cloudRes.data.public_id,
                  fileUrl: cloudRes.data.secure_url,
                  transcribe: this.question.answerCurrentTranscribe,
                }
              );

              this.question.answerTranscribe.push({
                public_id: cloudRes.data.public_id,
                secure_url: cloudRes.data.secure_url,
              });
            }
          });
        };
      });
    },
    stopRecording() {
      this.recordStatus = false;
      this.recordOptions.recording.stop();
      this.recordOptions.recording.stream.getTracks().forEach((i) => i.stop());
      this.speechOptions.recognition.stop();

      //this.question.answerTranscribe.push(this.question.answerCurrentTranscribe);
    },
    startTranscribing() {
      window.console.log("startTranscribing");

      let recognition = new (window.SpeechRecognition ||
        window.webkitSpeechRecognition ||
        window.mozSpeechRecognition ||
        window.msSpeechRecognition)();
      this.speechOptions.recognition = recognition;
      recognition.continuous = true;
      recognition.lang = "en-US";
      recognition.interimResults = true;
      recognition.maxAlternatives = 100;
      recognition.start();
      recognition.addEventListener("result", this.speechResult);
    },
    speechResult(event) {
      //const result = document.getElementById("result");
      let speechResultItem = [];
      for (const res of event.results) {
        if (res.isFinal) {
          speechResultItem.push(res[0].transcript);
          this.question.answerCurrentTranscribe = speechResultItem.join(". ");
        }
      }
    },
    openUploadModal() {
      window.cloudinary
        .openUploadWidget(
          { cloud_name: "channel1", upload_preset: "pwdrpypp", sources: ['local', 'camera'], clientAllowedFormats:['png', 'gif', 'pdf', 'jpg', 'jpeg', 'tiff', 'doc', 'docx'] },
          (error, result) => {
            if (!error && result && result.event === "success") {
              window.console.log("Done uploading..: ", result.info);

              const response = axios.post("user/uploadAttachmentDb", {
                topicId: `${this.$route.params.topicId}`,
                questionId: `${this.$route.params.questionId}`,
                userId: `${this.$route.params.userId}`,
                fileName: result.info.public_id,
                fileUrl: result.info.secure_url,
                created_at: result.info.created_at,
              });

              this.attachFiles.push(result.info);
            }
          }
        )
        .open();
    },
    async deleteAttachFile(public_id) {
      this.deleteAttachFiles.push(
        this.attachFiles.find((i) => i.public_id == public_id)
      );
      this.attachFiles = this.attachFiles.filter(
        (i) => i.public_id != public_id
      );

      const deleteFileAttachmentRes = await axios.get(
        `user/deleteFileAttachment/${public_id}`
      );
    },
    async onClickDeleteRecord(public_id, transcribeIndex) {
      //this.recordOptions.recordingFile = this.recordOptions.recordingFile.filter(
      //  (i) => i.public_id != public_id
      //);

      const deleteFileAttachmentRes = await axios.get(
        `user/deleteVideoAttachment/${public_id}`
      );
      this.question.answerTranscribe.splice(transcribeIndex, 1);
    },
    backToTopic() {
      this.$router.push(
        `/topics/${this.userId}/questions/${this.$route.params.topicId}`
      );
    },
    async saveAnswer() {
      //window.console.log(this.question.answerWritten);
      //window.console.log('saveAnswer');

      const saveAnswerRes = await axios.post(`user/saveAnswer`, {
        writtenAnswer: this.question.answerWritten,
        userId: `${this.$route.params.userId}`,
        topicId: `${this.$route.params.topicId}`,
        questionId: `${this.$route.params.questionId}`,
      });

      if (saveAnswerRes.data.success === true) {
        this.closeNotification.answerWritten = this.question.answerWritten;
        this.$swal(
          "Success!",
          "Your answer has been successfully updated",
          "success"
        );
        this.backToTopic();
      } else {
        this.$swal(
          "Error!",
          "Sorry, there is something wrong. Please contact your agent",
          "error"
        );
      }
    },
    async init() {
      try {
        const getAnswerRes = await axios.get(
          `user/getAnswer/${this.$route.params.userId}/${this.$route.params.topicId}/${this.$route.params.questionId}`
        );
        let getAnswers = getAnswerRes.data;

        this.topicTitle = getAnswers[0].topic;
        this.question.title = getAnswers[0].question;
        this.question.answerWritten = getAnswers[0].answer;
        this.question.order = getAnswers[0].questionOrder;
        this.closeNotification.answerWritten = getAnswers[0].answer;
      } catch (e) {
        window.console.log(e);
      }

      try {
        const getAnswerAttachmentRes = await axios.get(
          `user/getAnswerAttachment/${this.$route.params.userId}/${this.$route.params.topicId}/${this.$route.params.questionId}`
        );

        if (getAnswerAttachmentRes.data.length > 0) {
          this.attachFiles = getAnswerAttachmentRes.data;
        }
      } catch (e) {
        window.console.log(e);
      }

      try {
        const getAnswerVideoAttachmentRes = await axios.get(
          `user/getAnswerVideoAttachment/${this.$route.params.userId}/${this.$route.params.topicId}/${this.$route.params.questionId}`
        );

        if (getAnswerVideoAttachmentRes.data.length > 0) {
          this.question.answerTranscribe = getAnswerVideoAttachmentRes.data;

          window.console.log(this.question.answerTranscribe);
        }
      } catch (e) {
        window.console.log(e);
      }
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.userId = this.$route.params.userId;
    this.topicId = this.$route.params.topicId;
  },
  beforeRouteLeave(to, from, next) {
    window.console.log(this.closeNotification.answerWritten);
    window.console.log(this.question.answerWritten);
    if (this.closeNotification.answerWritten !== this.question.answerWritten) {
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>
<style lang="scss">
#result {
  color: blue;
  p.final {
    color: red;
  }
}
</style>
<style lang="scss" scoped>
.pageDescription {
  margin-top: 40px;
  margin-bottom: 40px;
  font-family: Effra-Regular;
  color: #5f5f5f;
  font-size: 17px;
  line-height: 25px;
}
.pageContentSubTitle {
  font-family: Effra-Heavy;
  font-size: 11px;
  color: #000000;
  letter-spacing: 0;
  margin-top: 58px;
  text-transform: uppercase;
}
.pageContentTitle {
  font-family: Effra-Light;
  font-size: 34px;
  color: #009ad6;
  letter-spacing: 0;
  line-height: 36px;
  margin-top: 20px;
}
.subPageController {
  display: inline-flex;
  align-items: center;
  padding: 7px 15px;
  font-family: Effra-Medium;
  font-size: 13px;
  color: #5f5f5f;
  letter-spacing: 0;
  line-height: 23px;
  background-image: linear-gradient(180deg, #f6f6f6 0%, #ffffff 100%);
  box-shadow: 0 4px 67px 0 rgba(0, 0, 0, 0.13);
  border-radius: 4px;
  position: absolute;
  bottom: -60px;
  left: 0;
  .pageLink {
    display: flex;
    align-items: center;
  }
  a {
    color: #5f5f5f;
    text-decoration: none;
  }
  .blue {
    color: #009cdc;
  }
  svg {
    font-size: 4px;
    margin-left: 15px;
    margin-right: 15px;
    &.backIcon {
      font-size: 16px;
      margin-left: 0px;
      margin-right: 20px;
    }
  }
}
.writtenAnswer {
  margin-top: 15px;
  .title {
    font-family: Effra-Heavy;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    margin-left: 15px;
    margin-bottom: 15px;
  }
  textarea {
    background-image: linear-gradient(180deg, #f6f6f6 0%, #ffffff 100%);
    box-shadow: 0 4px 67px 0 rgba(0, 0, 0, 0.13);
    border-radius: 8px;
    min-height: 200px;
    width: 100%;
    padding: 10px;
    font-family: Effra-Regular;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    line-height: 21px;
  }
}
.recordAnswerWrapper {
  margin-top: 45px;
  user-select: none;
  ._recordAnswerWrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
    //padding: 12px;
    //border-radius: 5px;
  }
  .title {
    font-family: Effra-Heavy;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    margin-left: 15px;
    margin-bottom: 15px;
  }
  .recordAnswer {
    width: 100%;
    .recordAnswerButtonWrapper {
      display: flex;
      align-items: center;
      justify-content: right;
      padding: 20px;
      background: #e8e8e8;
      border-radius: 8px;
      cursor: pointer;
      border: 2px solid transparent;
      transition: 0.25s all ease-in-out;
      &.recording {
        border: 2px solid #84bf25;
        .recordAnswerButton {
          color: #84bf25;
          svg {
            color: #84bf25;
          }
        }
      }
      .stopRecording {
        background-color: #d81818;
        border: 0px;
        border-radius: 4px;
        font-family: Effra-Medium;
        font-size: 12px;
        color: #ffffff;
        padding: 3px 11px;
        text-transform: uppercase;
        margin-top: 5px;
        cursor: pointer;
      }
      .recordAnswerButton {
        font-family: Effra-Heavy;
        font-size: 17px;
        color: #d81818;
        letter-spacing: 0;
        line-height: 23px;
        background: #ffffff;
        border-radius: 4px;
        text-transform: uppercase;
        padding: 6px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        svg {
          color: #d81818;
          font-size: 8px;
          margin-right: 6px;
        }
      }
      .recordAnswerInstruction {
        font-family: Effra-Regular;
        font-size: 14px;
        color: #000000;
        letter-spacing: 0;
        text-align: center;
        line-height: 17px;
      }
    }
    &:hover .recordAnswerButtonWrapper {
      background-color:#D3D3D3;
    }
  }
  .transcribeWrapper {
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
    .transcribeWrapperRow {
      padding: 20px;
      background: #e8e8e8;
      border-radius: 8px;
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .transcribeWrapperRowTitle {
        font-family: Effra-Regular;
        font-size: 14px;
        color: #000000;
        letter-spacing: 0;
        line-height: 17px;
      }
      .transcribeWrapperRowButtons {
        display: flex;
        .controls {
          display: flex;
          margin-right: 20px;
          .playRecord {
            margin-right: 20px;
            background: #009ad6;
            padding: 5px 10px;
            font-size: 12px;
            color: #fff;
            border-radius: 8px;
            cursor: pointer;
          }
          .downloadRecord {
            background: #000;
            padding: 5px 10px;
            font-size: 12px;
            color: #fff;
            border-radius: 8px;
            cursor: pointer;
            a {
              color: #ffffff;
              text-decoration: none;
            }
          }
        }
        .deleteRecord {
          background: #ff6262;
          padding: 5px 10px;
          font-size: 12px;
          color: #fff;
          border-radius: 8px;
          cursor: pointer;
        }
      }
    }
    textarea {
      background-image: linear-gradient(180deg, #f6f6f6 0%, #ffffff 100%);
      box-shadow: 0 4px 67px 0 rgba(0, 0, 0, 0.13);
      border-radius: 8px;
      min-height: 200px;
      width: 100%;
      padding: 10px;
      font-family: Effra-Regular;
      font-size: 14px;
      color: #000000;
      letter-spacing: 0;
      line-height: 21px;
      border: 0px;
    }
  }
  .answerDivider {
    font-family: Effra-Regular;
    font-size: 17px;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    line-height: 23px;
    margin-left: 15px;
    margin-right: 15px;
  }
}
.attachFilesWrapper {
  display: flex;
  margin-top: 60px;
  margin-bottom: 30px;

  @media (max-width: $lg) {
    flex-direction: column;
  }
  .left {
    img {
      max-width: 52px;
      margin-top: 20px;
    }
  }
  .mid {
    padding: 0 15px;
    flex: 1;

    @media (max-width: $lg) {
      padding: 0;
      margin-top: 10px;
    }
    .title {
      font-family: Effra-Heavy;
      font-size: 16px;
      color: #000000;
      letter-spacing: 0;
      border-bottom: 2px solid #d4d4d4;
      margin-bottom: 9px;
      padding-bottom: 9px;
    }
    .instruction {
      font-family: Effra-Regular;
      font-size: 14px;
      color: #5f5f5f;
      letter-spacing: 0;
      line-height: 21px;
      text-align: justify;
    }
  }
  .right {
    button {
      font-family: Effra-Medium;
      font-size: 14px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      line-height: 23px;
      background: #009ad6;
      border-radius: 4px;
      border: 0;
      padding: 7px 5px;
      width: 115px;
      margin-top: 15px;
    }
  }
}
.submitAnswerWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 20px;
  margin-top: 60px;

  @media (max-width: $lg) {
    display: flex;
    flex-direction: column;
  }
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    height: 2px;
    width: 100%;
    background-color: #d4d4d4;
    transform: translateY(-50%);

    @media (max-width: $lg) {
      display: none;
    }
  }
  button {
    font-family: Effra-Heavy;
    font-size: 16px;
    line-height: 18px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    background: #009ad6;
    border-radius: 5px;
    border: 0px;
    text-transform: uppercase;
    padding: 13px 30px;
    position: relative;
    z-index: 1;
    margin-left: 10px;
    margin-right: 10px;

    @media (max-width: $lg) {
      margin: 5px;
    }
  }
}
.attachFilesItems {
  display: flex;
  margin-bottom: 60px;
  .attachFilesItemsRow {
    position: relative;
    max-width: 150px;
    max-height: 150px;
    border: 1px solid #e8e8e8;
    align-items: center;
    justify-content: center;
    display: flex;
    margin-right: 2px;
    width: 25%;
    padding: 23px;
    .delete {
      position: absolute;
      top: 0;
      right: 0;
      background-color: #ff6262;
      box-shadow: inset 0 1px 4px 0 rgba(0, 0, 0, 0.09);
      height: 23px;
      width: 23px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      svg {
        color: #ffffff;
        font-size: 12px;
      }
    }
  }
}
.submitInstruction {
  font-family: Effra-Regular;
  font-size: 14px;
  color: #5f5f5f;
  letter-spacing: 0;
  line-height: 21px;
  text-align: justify;
  margin-bottom: 120px;
}
</style>